import isEmpty from 'lodash/isEmpty';
import draftToHtml from 'draftjs-to-html';
import ContentState from 'draft-js/lib/ContentState';
import convertToRaw from 'draft-js/lib/convertFromDraftStateToRaw';
import getEmbeddedComponent from './renderer/Embedded';
import getImageComponent from './renderer/Image';

export const customBlockRenderFunc = (block, config, editorState) => {
  // image entity will be included because on how `react-draft-wysiwyg`
  // handles custom block renderers
  if (block.getType() === 'atomic') {
    const contentState = editorState().getCurrentContent();
    const entity = contentState.getEntity(block.getEntityAt(0));
    if (entity && entity.type === 'IMAGE') {
      return {
        component: getImageComponent(config),
        editable: false,
      };
    } else if (entity && entity.type === 'EMBEDDED_LINK') {
      return {
        component: getEmbeddedComponent(config),
        editable: false,
      };
    }
  }
  return undefined;
};

export const isEditorContentStateEmpty = contentState => {
  if (!(contentState instanceof ContentState)) {
    throw new Error('argument is not instance of ContentState');
  }

  const isEditorEmpty = !contentState.hasText();
  const currentPlainText = contentState.getPlainText();
  return isEditorEmpty || isEmpty(currentPlainText);
};

export const extractEditorContentToHTML = (contentState, ...options) => {
  if (isEditorContentStateEmpty(contentState)) {
    return null;
  }

  // convert contentState -> raw -> html
  let html = draftToHtml(convertToRaw(contentState), ...options);

  // hacky patch to replace <ins></ins> with <u></u>
  // until draftjs is able to add it
  const tags = {
    ins: 'u',
  };

  const regex = exp => new RegExp(exp, 'g');
  for (var tag in tags) {
    const newTag = tags[tag];
    html = html
      .replace(regex(`<${tag}>`), `<${newTag}>`)
      .replace(regex(`</${tag}>`), `</${newTag}>`);
  }

  return html;
};
